import {TextField} from "@mui/material";

export default function PercentageProgressBar({
                                                  percentage,
                                                  onChange,
                                                  title,
                                                  name,
                                                  readonly,
                                                  color,
                                                  narrow = false,
                                                  align = "left",
                                                  usePercentage = false,
                                                  value
                                              }) {

    const normalizedPercentage = Math.min(Math.max(0, percentage), 100);
    const progressWidth = `${normalizedPercentage}%`;
    const bgColor = color === undefined ?
        (percentage <= 100.0 ? `rgba(0, 255, 0, 0.4)` : `rgba(255, 0, 0, 0.4)`) : color;

    return (
        <TextField
            value={value || ((percentage || '0 %') + (percentage && usePercentage === true ? ' %' : ''))}
            label={title}
            fullWidth
            margin="normal"
            name={name}
            onChange={onChange}
            slotProps={{
                input: {...(readonly && {style: {pointerEvents: 'none', backgroundColor: 'whitesmoke'}})},
                htmlInput: {
                    min: 0,
                    max: 100,
                    style: {
                        background: `linear-gradient(to right, ${bgColor} ${progressWidth}, transparent ${progressWidth})`,
                        WebkitAppearance: 'none',
                        MozAppearance: 'textfield',
                        appearance: 'textfield',
                        height: narrow ? "0px" : "auto",
                        margin: narrow ? "0px" : "auto",
                        padding: narrow ? "15px" : "auto",
                        borderRadius: "5px",
                        textAlign: align
                    }
                }
            }}
            style={{transition: 'background-color 0.3s'}}
        />
    );
};